// extracted by mini-css-extract-plugin
module.exports = {"h1":"Headings_h1__36ai_","h2":"Headings_h2__16yrj","h5":"Headings_h5__60Ze6"};